import { render, staticRenderFns } from "./RegisterRequest.vue?vue&type=template&id=0cee8edf"
import script from "./RegisterRequest.vue?vue&type=script&lang=js"
export * from "./RegisterRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports